import http from '../../http'
export default {
  list: (params) => {
    return http.post('activityservice/contact/page', params)
  },
  add: (params) => {
    // 新增修改统一接口
    return http.post('activityservice/contact/upsert', params)
  },
  treeArr: (params) => {
    return http.get('activityservice/contactOrg/listAll', params)
  },
  treeSave: (params) => {
    return http.post('activityservice/contactOrg/saveAll', params)
  },
  updateAll: (params) => {
    // 批量修改接口 启用/禁用功能
    return http.post('activityservice/contact/batch', params)
  },
  delAll: (params) => {
    return http.post('activityservice/contact/batchdelete', params)
  },
  export: (params) => {
    return http.post('activityservice/contact/export', params)
  },
  promise: (params) => {
    return http.get('/activityservice/privilege/list/' + params)
  },
  promistUpdate: (params) => {
    return http.post('activityservice/privilege/upsert', params)
  }
}